export default {
    plan: null,
    seats: null,
    isReadingPlan: false,
    isDiscoveringWebsite: false,
    isGeneratingRecommendations: false,
    isGeneratingTeamStructure: false,
    isExtractingInvites: false,
    isGeneratingPhoneSetup: false,
    isDraftingGreetings: false,
    isGeneratingCrmSetup: false,
    isGeneratingMessagingSetup: false,
    isMappingColumns: false,
    isAnalyzingImport: false,
    isLoadingSampleImport: false,
    isGeneratingIntegrations: false
};
